import L from 'leaflet';
import { renderToStaticMarkup } from 'react-dom/server';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

export function createVehiclePositionIcon(
    color = '#c51414'
) {

    const iconHtml =
        renderToStaticMarkup(
            <div
                style={{
                    position: 'relative',

                    width: 42,
                    height: 42,

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <LocationOnIcon
                    style={{
                        position: 'absolute',

                        fontSize: 42,

                        color
                    }}
                />

                <DirectionsBusIcon
                    style={{
                        position: 'absolute',

                        top: 8,

                        fontSize: 18,

                        color: '#ffffff',

                        backgroundColor: color
                    }}
                />
            </div>
        );

    return L.divIcon({
        className: 'pezinho-vehicle-marker',

        html: iconHtml,

        iconSize: [
            42,
            42
        ],

        iconAnchor: [
            21,
            39
        ],

        popupAnchor: [
            0,
            -28
        ]
    });
}